import { appToken, serverApiUrl, serverNodeApiUrl } from "../../index";

const token =
  "Bearer " + "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdGF0dXMiOiJVTkJMT0NLRUQiLCJpZCI6ODkyMjA2ODc5MCwibW9iaWxlIjoiJDJiJDEwJG43TEZEeTJSaXJEa1lYelNuSWlIcU90WlUzcC9SaU9jZUNmUWZLVzFQYzV6WWZabzRNZElpIiwidXNlclR5cGUiOiJBRE1JTiIsInVwZGF0ZWRBdCI6IjIwMjUtMDItMjZUMDk6MDg6MDIuNDkxWiIsImNyZWF0ZWRBdCI6IjIwMjUtMDItMjZUMDk6MDg6MDIuNDkxWiIsImlhdCI6MTc0MDU2MDg4MiwiZXhwIjoxNzQzMTg4ODgyLCJpc3MiOiJEVUJ1ZGR5In0.QzQhSkCs2juC-06HGHwBbXIDVTPLjv78715QMcXIROM";
export const fetchSubCategory = async (testTypeId, page, limit) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // headers.append('Access-Control-Allow-Origin', serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);

    const response = await fetch(
      serverNodeApiUrl +
      "testseries/admin/examTestType/testSeriesExamTestTypeSubCategory/" +
      testTypeId +
      "/" +
      page +
      "/" +
      limit,
      // serverApiUrl + 'testSeriesExamTestTypeSubCategory/' ,
      {
        method: "GET",
        headers,
      }
    );
    if (response.status == 200) {
      const data = await response.json();
      return {
        status: true,
        data: data,
        message: "category fetched successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
export const addSubCategory = async (data) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);

    const response = await fetch(
      serverNodeApiUrl + "testseries/admin/examTestType/testSeriesExamTestTypeSubCategory/",
      //   serverApiUrl + "testSeriesExamTestTypeSubCategory/",
      {
        method: "POST",
        headers,
        body: JSON.stringify(data),
      }
    );
    if (response.status == 200) {
      const data = await response.json();
      return data
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
export const editSubCategory = async (data) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);

    const response = await fetch(
      serverNodeApiUrl + "testseries/admin/testseries/testSeriesExamTestTypeSubCategory",

      //   serverApiUrl + "testSeriesExamTestTypeSubCategory/",
      {
        method: "PUT",
        headers,
        body: JSON.stringify(data),
      }
    );
    if (response.status == 200) {
      const data = await response.json();
      return {
        status: true,
        data: data,
        message: "category fetched successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const deleteSubCategory = async (id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      serverApiUrl + "testSeriesExamTestTypeSubCategory/" + id,
      {
        method: "DELETE",
        headers,
      }
    );
    if (response.status == 200) {
      return { status: true, message: "category deleted successfully." };
    } else {
      throw new Error("Something went wrong, while deleting data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

// count users attempted by test series exam test type sub-category
export const countUsersAttemptedByTestSeriesExamTestTypeSubCategoryId = async (
  id
) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestTypeSubCategory/exam-test-type-subcategory/" +
      id +
      "/users-attempted"
    );
    const count = await response.json();
    return { status: true, data: count };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

// count users submitted by test series exam test type sub-category
export const countUsersSubmittedByTestSeriesExamTestTypeSubCategoryId = async (
  id
) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestTypeSubCategory/exam-test-type-subcategory/" +
      id +
      "/users-submitted"
    );
    const count = await response.json();
    return { status: true, data: count };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

// get average score by test series exam test type sub-category
export const getAverageScoreByTestSeriesExamTestTypeSubCategoryId = async (
  id
) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestTypeSubCategory/exam-test-type-subcategory/" +
      id +
      "/average-score"
    );
    const averageScore = await response.json();
    return { status: true, data: averageScore };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

// get highest score by test series exam test type sub-category
export const getHighestScoreByTestSeriesExamTestTypeSubCategoryId = async (
  id
) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestTypeSubCategory/exam-test-type-subcategory/" +
      id +
      "/highest-score"
    );
    const highestScore = await response.json();
    return { status: true, data: highestScore };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

// get lowest score by test series exam test type sub-category
export const getLowestScoreByTestSeriesExamTestTypeSubCategoryId = async (
  id
) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestTypeSubCategory/exam-test-type-subcategory/" +
      id +
      "/lowest-score"
    );
    const lowestScore = await response.json();
    return { status: true, data: lowestScore };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

// get average time taken by test series exam test type sub-category
export const getAverageTimeTakenByTestSeriesExamTestTypeSubCategoryId = async (
  id
) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestTypeSubCategory/exam-test-type-subcategory/" +
      id +
      "/average-time-taken"
    );
    const averageTimeTaken = await response.json();
    return { status: true, data: averageTimeTaken };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

// get paid users count by test series exam test type sub-category
export const getPaidUsersCountByTestSeriesExamTestTypeSubCategoryId = async (
  id
) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestTypeSubCategory/exam-test-type-subcategory/" +
      id +
      "/paid-users-count"
    );
    const paidUsersCount = await response.json();
    return { status: true, data: paidUsersCount };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const getTop10PerformingTestSeriesBySubCategoryBasedOnAvgScore = async (
  id
) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestTypeSubCategory/top-performing/subcategory/" +
      id +
      "/average-score"
    );
    const testSeries = await response.json();
    return { status: true, data: testSeries };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};
